import { FC } from 'react';

import { IonButtons, IonBackButton, IonButton, IonIcon } from '@ionic/react';

import { ICONS_BASE64 } from '../../Icon';

interface HeaderCloseProps {
  defaultHref?: string;
  onClick?: () => void;
}

export const HeaderClose: FC<HeaderCloseProps> = ({ defaultHref, onClick }) => {
  return (
    <IonButtons slot="end">
      {onClick ? (
        <IonButton onClick={onClick} shape="round">
          <IonIcon slot="icon-only" icon={ICONS_BASE64.x} />
        </IonButton>
      ) : (
        <IonBackButton icon={ICONS_BASE64.x} defaultHref={defaultHref} />
      )}
    </IonButtons>
  );
};
